const pt = {
  translation: {
    messages: {
      title: "Mensagens",
      loading: "Carregando…",
      sending: "Enviando…",
      send: "Enviar",
      back: "Voltar",
      you: "Você",
      input_placeholder: "Escreva uma mensagem…",
      thread_empty: "Ainda não há mensagens nesta conversa. Quebre o gelo.",
      load_more: "Ver mensagens anteriores",
      select_conversation: "Escolha uma conversa para lê-la aqui.",
      compose_hint: "Você vai escrever para {{name}}. Sua primeira mensagem abre a conversa.",
      message_action: "Mensagem",
      send_error: "Não foi possível enviar a mensagem. Tente novamente.",
      empty_title: "Sua garagem ainda está em silêncio",
      empty_body: "Quando você se conectar com outro colecionador, a conversa fica aqui. Passe por um perfil e comece a troca.",
      now: "agora",
      min_ago: "há {{count}} min",
      hour_ago: "há {{count}} h",
      yesterday: "ontem",
      days_ago: "há {{count}} d",
    },
    nav: {
      explore: "Explorar",
      auctions: "Leilões",
      community: "Comunidade",
      login: "Entrar",
      upload: "Publicar",
      bulk_upload: "Enviar várias peças",
      panel: "Painel",
      messages: "Mensagens",
      language: "Idioma",
      pricing: "Preços",
    },
    pricing: {
      meta_title: "Preços — Troly",
      meta_desc: "Planos da Troly para colecionadores, vendedores e marcas.",
      eyebrow: "Planos",
      title: "Escolha seu plano",
      subtitle: "Comece grátis. Cresça quando sua coleção pedir.",
      per_year: "/ano",
      per_month_equiv: "≈ {{price}}/mês",
      custom_price: "Preço personalizado",
      badge_popular: "Mais popular",
      badge_current: "Seu plano atual",
      free: "Grátis",
      free_forever: "para sempre",
      cta_start: "Começar agora",
      cta_sales: "Contatar vendas",
      wa_sales_message: "Olá, tenho interesse no plano Troly Seller. Podem me enviar mais informações?",
      cta_loading: "Redirecionando para a Stripe…",
      cta_manage: "Gerenciar assinatura",
      checkout_error: "Não foi possível iniciar o pagamento. Tente novamente.",
      plans: {
        pro: {
          name: "Troly Pro",
          tagline: "Para o colecionador ativo",
          note: "Conheça mais colecionadores, sem cartão",
          features: [
            "Carregar peças e organizar coleção",
            "Alerta de peças repetidas",
            "Acesso à comunidade",
            "Mensagens entre colecionadores",
            "Busque peças e consulte o preço",
          ],
        },
        premium: {
          name: "Troly Premium",
          tagline: "Para quem coleciona, vende e troca",
          note: "Entre no clube e viva uma experiência diferente",
          features: [
            "Tudo do Pro",
            "Perfil público da coleção",
            "Marcar peças à venda, troca ou exposição",
            "Verificação de usuário",
            "Ganhe seguidores para sua coleção",
          ],
        },
        seller: {
          name: "Troly Seller",
          tagline: "Para vendedores, distribuidores e marcas",
          desc: "Desenvolvemos as ferramentas que sua operação precisa: métricas de vendedor, integrações, suporte dedicado e SLA garantido.",
          features: [
            "Tudo do Premium",
            "Métricas de vendedor (conversão, demanda)",
            "Integrações personalizadas",
            "Suporte dedicado e SLA garantido",
            "Aviso automático aos seguidores quando você coloca peças à venda",
          ],
        },
      },
    },
    premium_success: {
      meta_title: "Bem-vindo ao Troly Premium — Troly",
      eyebrow: "Troly Premium",
      verifying_title: "Confirmando seu pagamento…",
      verifying_text: "Estamos verificando sua assinatura com a Stripe. Isso leva apenas alguns segundos.",
      title: "Agora você é Premium!",
      text: "Sua assinatura está ativa. Aproveite seu perfil público, marque peças à venda ou troca e exiba seu selo de confiança.",
      cta_profile: "Ir para meu perfil",
      error_title: "Não foi possível confirmar o pagamento",
      error_text: "Se a cobrança foi realizada, sua conta será atualizada automaticamente em alguns minutos. Caso contrário, tente novamente na página de preços.",
      cta_back: "Voltar aos preços",
    },
    navbar: {
      search_placeholder: "Buscar peças, marcas, colecionadores...",
      searching: "Buscando…",
      no_results: "Sem resultados para",
      pieces: "Peças",
      collectors: "Colecionadores",
      see_all_results: "Ver todos os resultados",
      home: "Início",
      light_mode: "Modo claro",
      dark_mode: "Modo escuro",
      admin: "Admin",
      language: "Idioma",
      my_profile: "Meu Perfil",
      cart: "Carrinho",
      settings: "Configurações",
      logout: "Sair",
    },
    home: {
      hero_eyebrow: "UM APP, TODA A SUA COLEÇÃO",
      hero_title: "Descubra quanto vale",
      hero_accent: "a sua coleção.",
      hero_sub: "Da sua primeira peça ao seu grail mais procurado, o Troly reúne tudo o que você coleciona em um só lugar e mostra quanto vale, na sua moeda.",
      meta_title: "Troly — Descubra quanto vale a sua coleção",
      meta_desc: "Organize sua coleção de miniaturas, veja o valor total na sua moeda e conecte-se com outros colecionadores.",
      filters: {
        all: "Todos os Modelos",
        sale: "À Venda",
        trade: "Para Troca",
        display: "Apenas Exposição",
        classic: "Clássicos",
        hypercar: "Hypercars",
      },
      search_query_chip: "Busca",
      clear_search: "Limpar busca",
      loading: "Carregando peças…",
      load_error: "Não foi possível carregar o catálogo. Tente novamente em alguns minutos.",
      empty_category: "Ainda não há peças nesta categoria.",
      community: "Comunidade",
      search_placeholder: "Buscar clássicos, exóticos...",
      features: {
        eyebrow: "POR QUE TROLY",
        title: "Tudo o que a sua coleção precisa",
        subtitle: "Suba uma vez e o Troly cuida do resto: quanto vale, como você organiza e com quem compartilha.",
        value_title: "O valor da sua coleção, sempre à mão",
        value_desc: "Cada peça que você sobe soma ao seu Valor Total. O Troly calcula com os preços do catálogo e mostra na sua moeda.",
        value_cta: "Ver meu valor total",
        prices_title: "Preços do catálogo",
        prices_desc: "Busque qualquer peça e consulte o preço antes de comprar, vender ou trocar.",
        prices_cta: "Explorar o catálogo",
        organize_title: "Sua garagem organizada",
        organize_desc: "Pastas, escalas e filtros para achar qualquer peça em segundos, por maior que seja a sua coleção.",
        organize_cta: "Subir minhas peças",
        trade_title: "À venda ou para troca",
        trade_desc: "Marque as peças que você quer vender ou trocar e deixe outros colecionadores te encontrarem.",
        trade_cta: "Ver planos",
        community_title: "Comunidade de colecionadores",
        community_desc: "Perfil público, seguidores e mensagens diretas com quem coleciona o mesmo que você.",
        community_cta: "Conhecer o clube",
      },
      footer: {
        tagline: "Organize sua coleção, saiba quanto ela vale e conecte-se com outros colecionadores.",
        platform: "Plataforma",
        company: "Empresa",
        legal: "Legal",
        raffle: "Termos do Sorteio",
        pricing: "Preços",
        security: "Segurança",
        about: "Sobre",
        blog: "Blog",
        careers: "Carreiras",
        privacy: "Privacidade",
        terms: "Termos",
        copyright: "© 2026 TROLY MARKETPLACE · TODOS OS DIREITOS RESERVADOS",
      },
    },
    trigger: {
      title: "Clube exclusivo para colecionadores de carrinhos",
      desc: "Entrar é grátis e sem dados de cartão. Só verificamos seu e-mail com um código para manter a qualidade e a segurança da comunidade.",
      have_code: "Tenho um código de convite",
      join_waitlist: "Entrar no clube",
      have_account: "Já tenho uma conta",
      fast_track_divider: "ACESSO RÁPIDO",
      fast_track_text: "Acelere seu acesso ao clube. Verifique seu perfil com Facebook e enviamos o código de convite na hora.",
      fb_button: "Continuar com Facebook",
      fb_loading: "Conectando ao Facebook…",
      fb_cancelled: "Você cancelou o login com Facebook.",
      fb_error: "Não conseguimos concluir o login com Facebook.",
      fb_sdk_error: "Falha ao carregar o Facebook. Tente novamente.",
      fb_email_required: "Sua conta do Facebook não tem e-mail associado. Use outra opção de entrada.",
      fb_not_configured: "O login com Facebook ainda não está disponível.",
    },
    invite_code: {
      title: "Digite seu código de convite",
      desc_l1: "Enviamos um código de verificação para seu e-mail.",
      desc_l2: "Verifique sua caixa de entrada ou pasta de spam.",
      from_fb_hint: "Enviamos seu código de convite para {{email}}. Verifique sua caixa de entrada ou pasta de spam.",
      err_incomplete: "Digite os 6 caracteres",
      err_invalid: "Código inválido",
      validate: "Validar",
      validating: "Validando...",
      resend: "Reenviar código",
    },
    waitlist: {
      badge: "Em breve",
      title: "Você está a um passo de entrar no clube",
      desc: "Deixe seu e-mail e enviamos seu código de acesso na hora.",
      email_placeholder: "Digite seu e-mail",
      err_no_email: "Digite seu e-mail",
      err_register: "Erro ao registrar",
      submit: "Enviar meu código",
      submitting: "Registrando...",
      wait_label: "Tempo de espera:",
      wait_value: "0 dias",
    },
    waitlist_done: {
      title: "Você já está na fila do clube",
      received: "Registro recebido!",
      you_are: "Você é o colecionador",
      in_queue: "na fila",
      skip_title: "Quer pular a fila?",
      skip_desc: "Encontre um amigo que já está na Troly e peça um dos seus convites.",
      have_code_btn: "Já tenho um código",
    },
    login_pg: {
      welcome: "Bem-vindo de volta",
      err_invalid: "Credenciais inválidas",
      email_label: "E-mail",
      email_placeholder: "nome@exemplo.com",
      password_label: "Senha",
      forgot: "Esqueci minha senha",
      submit: "Entrar",
      submitting: "Entrando...",
      no_account: "Ainda não tem uma conta?",
      register: "Cadastrar-me",
    },
    register_pg: {
      title: "Crie sua garagem digital",
      subtitle: "Seu plano Troly Pro é grátis, para sempre. Sem cartão.",
      err_pass_mismatch: "As senhas não coincidem",
      err_loc_required: "Digite sua cidade e país",
      err_register: "Erro ao registrar",
      name_label: "NOME COMPLETO",
      name_placeholder: "Seu nome",
      email_label: "E-MAIL",
      email_placeholder: "email@exemplo.com",
      password_label: "SENHA",
      confirm_label: "CONFIRMAR SENHA",
      city_label: "CIDADE",
      city_placeholder: "São Paulo",
      country_label: "PAÍS",
      country_placeholder: "Brasil",
      code_label: "CÓDIGO DE CONVITE",
      code_placeholder: "XXX-XXX",
      email_locked_hint: "Verificado com Facebook",
      submit: "Criar conta →",
      submitting: "Criando conta...",
      have_account: "Já tem uma conta?",
      login_link: "Entre",
    },
    auth_shell: {
      copyright: "© 2026 TROLY HIGH PERFORMANCE COLLECTIBLES",
    },
    auth: {
      welcome_back: "Bem-vindo de volta",
      welcome_sub: "Acesse seu cofre privado de colecionador",
      google: "Continuar com Google",
      facebook: "Continuar com Facebook",
      or_email: "OU ENTRAR COM E-MAIL",
      email_label: "ENDEREÇO DE E-MAIL",
      email_placeholder: "nome@exemplo.com",
      password_label: "SENHA",
      forgot: "Esqueceu sua senha?",
      login_btn: "Entrar",
      no_account: "Não tem uma conta?",
      register_link: "Cadastre-se",
      create_title: "Crie sua garagem digital",
      name_label: "NOME COMPLETO",
      name_placeholder: "Seu nome",
      confirm_label: "CONFIRMAR SENHA",
      terms: "Aceito os",
      terms_link: "Termos e Condições",
      terms_and: "e a política de privacidade.",
      register_btn: "Criar conta",
      have_account: "Já tem uma conta?",
      login_link: "Entre",
    },
    profile: {
      invite: "Convidar amigos",
      total_value: "VALOR TOTAL",
      pieces: "PEÇAS",
      unique: "Modelos únicos",
      followers: "SEGUIDORES",
      following: "SEGUINDO",
      collectors: "Colecionadores",
      my_collection: "Minha Coleção",
      see_all: "Ver toda a coleção",
      filters: { all: "Todos" },
      scale_all: "Todas",
      usd_estimated: "USD estimado",
      hidden_public: "oculto ao público",
      in_garage: "na sua garagem",
      for_sale: "À VENDA",
      active: "ativas",
      trade: "TROCA",
      available: "disponíveis",
      enter_raffle: "Participar do sorteio",
      invite_friend: "Convidar um amigo",
      upgrade_plan: "Melhorar plano",
      seller_badge: "VENDEDOR TROLY",
      seller_panel: "Painel do vendedor",
      seller_request_pending: "Solicitação pendente",
      seller_request_sending: "Enviando…",
      seller_request: "Solicitar ser vendedor",
      seller_request_again: "Solicitar ser vendedor (novamente)",
      seller_request_rejected_title: "Sua solicitação anterior foi rejeitada — você pode solicitar novamente",
      seller_request_auto: "Você colocou uma peça à venda, então enviamos sua solicitação para ser vendedor à equipe admin do Troly. Você precisa esperar a aprovação; os detalhes estão nas suas mensagens e no seu e-mail.",
      hide_public: "Ocultar do público",
      show_public: "Mostrar ao público",
      loading_collection: "Carregando sua coleção…",
      no_pieces: "Você ainda não enviou peças. ",
      no_in_scale: "Você não tem peças nesta escala. ",
      upload_first: "Envie a primeira",
      collections_label: "Pastas",
      collection_all: "Todas",
      collection_new: "+ Nova pasta",
      collection_manage: "Gerenciar pastas",
      collection_empty_filter: "Não há peças nesta pasta. Toque no ícone 📁 sobre uma peça para atribuí-la.",
      collection_modal: {
        new_title: "Nova pasta",
        edit_title: "Editar pasta",
        name_label: "Nome",
        name_placeholder: "Ex. Clássicos JDM",
        desc_label: "Descrição (opcional)",
        public_label: "Visível no meu perfil público",
        save: "Salvar",
        saving: "Salvando…",
        cancel: "Cancelar",
        delete: "Excluir pasta",
        delete_confirm: "Excluir a pasta? As peças não são excluídas, apenas removidas da pasta.",
      },
      pub_folders_modal: {
        title: "Pastas desta peça",
        empty: "Você ainda não tem pastas. Crie uma na seção de pastas.",
        save: "Salvar",
        saving: "Salvando…",
      },
      pub_folders_btn: "Pastas",
      free_modal: {
        title: "Participe do próximo sorteio",
        unlocked: "🎉 Você conseguiu! Sua participação neste sorteio foi ativada. Quando o próximo sorteio começar, você poderá participar novamente cumprindo as mesmas condições.",
        intro: "Compartilhe seu código pessoal com outros colecionadores e complete estes três passos:",
        step1: "Convide quatro colecionadores usando seu código:",
        step2: "Faça com que os quatro concluam o cadastro na Troly",
        step3: "Suba pelo menos quatro peças da sua própria coleção",
        your_numbers: "Seus números",
        next_number: "Faltam {{count}} indicados para o seu próximo número.",
        label_referrals: "Indicados cadastrados",
        label_pieces: "Peças enviadas",
        foot: "Uma vez cumpridas as três condições, sua participação no próximo sorteio é ativada automaticamente — o ganhador será anunciado na nossa página do Facebook.",
        territory_note: "Sorteio válido para colecionadores em {{territory}}.",
        email_placeholder: "email@exemplo.com",
        cancel: "Cancelar",
        sending: "Enviando…",
        send: "Enviar",
        share_email: "Compartilhar por e-mail",
        share_whatsapp: "Compartilhar por WhatsApp",
        sent_to: "Convite enviado para {{email}} ✓",
        err_invalid_email: "Digite um e-mail válido.",
        err_send_failed: "Não foi possível enviar o e-mail. Tente novamente.",
        wa_message: "Convido você para a Troly, o clube de colecionadores de carros em escala. Use meu código {{code}} para entrar: {{url}}",
      },
      invite_modal: {
        title: "Convide um amigo para a Troly",
        intro: "Gere um código de uso único para um amigo se cadastrar na Troly. Compartilhe por e-mail ou WhatsApp.",
        remaining_one: "Você tem {{count}} convite disponível.",
        remaining_other: "Você tem {{count}} convites disponíveis.",
        none_left: "Você não tem convites disponíveis no momento.",
        code_generated: "Seu código de convite:",
        email_placeholder: "email@exemplo.com",
        cancel: "Cancelar",
        sending: "Enviando…",
        send: "Enviar",
        share_email: "Convidar por e-mail",
        share_whatsapp: "Convidar por WhatsApp",
        sent_to: "Convite enviado para {{email}} ✓",
        err_invalid_email: "Digite um e-mail válido.",
        err_send_failed: "Não foi possível enviar o e-mail. Tente novamente.",
        err_generate_failed: "Não foi possível gerar o convite. Tente novamente.",
        wa_message: "Convido você para a Troly, o clube de colecionadores de carros em escala. Use meu código de convite {{code}} para entrar: {{url}}",
      },
      member_chip: {
        title: "Seu número de membro",
        text: "Você é o membro #{{number}} da Troly",
      },
    },
    upload: {
      title: "Nova Peça",
      subtitle: "Complete os detalhes técnicos para publicar sua peça no catálogo da Troly.",
      drop_title: "Arraste as fotos aqui",
      drop_sub: "Suporta JPG, PNG até 10MB por imagem",
      name_label: "Nome da peça",
      name_placeholder: "Pontiac GTO 1967",
      year_label: "Ano",
      year_placeholder: "2024",
      sku_label: "SKU (Toy Number)",
      sku_placeholder: "Ex. HNL21 / HW2024-001",
      brand_label: "Marca",
      brand_placeholder: "Selecionar marca",
      scale_label: "Escala",
      scale_placeholder: "Selecionar escala",
      action_label: "Ação",
      action_placeholder: "Mostrar (Share)",
      category_label: "Categoria",
      category_placeholder: "Selecionar categoria",
      price_label: "Preço",
      price_amount: "Preço",
      price_currency: "Moeda",
      negotiable: "Negociável",
      material_label: "Material",
      material_placeholder: "Selecionar material",
      desc_label: "Descrição",
      desc_placeholder: "Descreva o estado da peça, compatibilidade técnica e detalhes adicionais...",
      publish_btn: "Publicar Peça",
      draft_btn: "Salvar Rascunho",
      tips_title: "DICAS TROLY",
      tip1: "Use iluminação natural para realçar os detalhes do material.",
      tip2: "Especifique a escala exata para evitar devoluções desnecessárias.",
      tip3: "Peças com certificado de autenticidade vendem 40% mais rápido.",
      err_publish: "Erro ao publicar",
      publishing: "Publicando...",
      select: "Selecionar",
      action_options: { Mostrar: "Exibir", Venta: "Venda", Cambio: "Troca" },
      action_upgrade_notice: "Você precisa melhorar seu plano para colocar peças à venda ou troca.",
      action_upgrade_link: "Ver planos",
    },
    settings: {
      meta_title: "Configurações — Troly",
      title: "Configurações",
      loading: "Carregando…",
      photo_profile: "Foto e perfil",
      upload_photo: "Enviar foto",
      photo_hint: "JPG, PNG ou WebP — máx 5 MB.",
      bio_label: "Descrição",
      bio_placeholder: "Conte brevemente sobre sua coleção…",
      location_label: "Localização",
      location_placeholder: "Cidade do México, México",
      location_hint: "Cidade e país. Usado em dinâmicas como o sorteio.",
      website_label: "Site",
      save_profile: "Salvar perfil",
      change_password: "Alterar senha",
      current_password: "Senha atual",
      new_password: "Nova senha",
      confirm_new_password: "Confirmar nova senha",
      update_password: "Atualizar senha",
      change_email: "Alterar e-mail",
      current_email: "E-mail atual:",
      new_email: "Novo e-mail",
      confirm_password: "Confirme sua senha",
      change_email_btn: "Alterar e-mail",
      session: "Sessão",
      logout: "Sair",
      privacy: "Privacidade do perfil",
      privacy_public_label: "Perfil público",
      privacy_public_hint: "Seu perfil aparece na busca e qualquer pessoa pode vê-lo sem se cadastrar. Se desativar, só os membros do Troly poderão vê-lo.",
      privacy_total_label: "Mostrar o valor total da minha coleção",
      privacy_total_hint: "Se desativar, o valor total aparece oculto («••••») para os demais visitantes.",
      privacy_prices_label: "Mostrar o preço das minhas peças",
      privacy_prices_hint: "Se desativar, o preço de cada peça fica oculto no seu perfil para quem não fez login.",
      notifications: "Notificações",
      notif_messages_label: "Avisar por e-mail quando eu receber mensagens",
      notif_messages_hint: "Enviamos um e-mail para seu endereço cadastrado quando outro colecionador escreve para você no Troly.",
      comms_lang_label: "Idioma das comunicações do Troly",
      comms_lang_hint: "Em que idioma você quer receber nossos e-mails: convites, códigos de acesso, avisos de compra e propostas de troca.",
      comms_lang_auto: "Automático (conforme sua localização)",
      cancel_account: "Cancelar conta",
      cancel_account_warn: "Excluirá seu perfil, suas peças e convites pendentes. Não pode ser desfeito.",
      cancel_my_account: "Cancelar minha conta",
      modal_title: "Cancelar sua conta?",
      modal_warn: "Esta ação excluirá permanentemente seu perfil e suas peças.",
      modal_confirm_label: "Confirme com sua senha",
      back: "Voltar",
      delete: "Excluir",
      msg: {
        privacy_ok: "Preferência de privacidade salva.",
        privacy_err: "Não foi possível salvar a preferência de privacidade",
        notif_ok: "Preferência salva.",
        notif_err: "Não foi possível salvar a preferência",
        comms_lang_ok: "Idioma das comunicações salvo.",
        comms_lang_err: "Não foi possível salvar o idioma das comunicações",
        photo_ok: "Foto atualizada.",
        photo_err: "Não foi possível enviar a imagem",
        profile_ok: "Perfil salvo.",
        profile_err: "Erro ao salvar",
        pw_required: "Digite a senha atual e a nova",
        pw_short: "A nova senha deve ter pelo menos 6 caracteres",
        pw_mismatch: "A confirmação não coincide",
        pw_ok: "Senha atualizada.",
        pw_err: "Erro ao atualizar a senha",
        email_required: "Digite o novo e-mail e sua senha",
        email_ok: "E-mail atualizado.",
        email_err: "Erro ao alterar o e-mail",
        del_pw_required: "Confirme sua senha",
        del_err: "Erro ao cancelar a conta",
      },
    },
    listing: {
      loading: "Carregando peça...",
      not_found: "Peça não encontrada",
      load_error: "Não foi possível carregar a peça",
      no_image: "Sem imagem",
      image_alt: "Imagem",
      brand: "Marca",
      category: "Categoria",
      material: "Material",
      launch_year: "Ano de lançamento",
      sku: "SKU (Código)",
      scale: "Escala",
      action: "Ação",
      location: "Localização",
      views: "Visualizações",
      description: "Descrição",
      paywall_desc: "A descrição detalhada está disponível para assinantes Troly.",
      published_by: "Publicada por",
      collector: "Colecionador",
      price: "Preço",
      paywall_logged: "Assine a Troly para ver preços e comprar.",
      paywall_anon: "Entre e assine para ver preços.",
      subscribe: "Assinar",
      sign_in: "Entrar",
      price_low: "Baixo:",
      price_mid: "Médio:",
      price_high: "Alto:",
      market_value: "Valor de referência",
      market_value_note: "Estimativa de mercado — não é uma oferta de venda.",
      consult: "Consultar",
      contact_seller: "Contatar vendedor",
      contact_owner: "Contatar o dono",
      traders_title: "Quem aceita troca",
      contact_modal_title: "Contatar o dono",
      contact_modal_subtitle: "Vamos enviar um e-mail com sua mensagem. Seu e-mail será o remetente para que ele possa responder diretamente.",
      contact_modal_placeholder: "Olá, tenho interesse na sua peça. O que você gostaria de trocar?",
      contact_modal_send: "Enviar mensagem",
      contact_modal_cancel: "Cancelar",
      contact_modal_sending: "Enviando…",
      contact_modal_sent: "Mensagem enviada! O dono receberá sua proposta por e-mail.",
      contact_modal_error: "Não foi possível enviar o e-mail. Tente novamente mais tarde.",
    },
    listing_card: {
      subscribe: "Assinar",
      subscribe_tooltip: "Assine para ver preços",
      action: { Venta: "VENDA", Cambio: "TROCA", Mostrar: "EXIBIR" },
      add_to_cart: "Adicionar ao carrinho",
      view_cart: "Ver carrinho",
      contact_owner: "Contatar o dono",
    },
    admin: {
      loading: "Carregando...",
      back: "Voltar",
      brand: "Troly · Admin",
      title: "Painel de admin",
      subtitle_p1: "Gerencie a lista de espera e os convites enviados de",
      stat_total: "Total na lista",
      stat_pending: "Pendentes",
      stat_invites_sent: "Convites enviados",
      stat_my_invites: "Meus convites",
      tab_waitlist: "Lista de espera",
      tab_invites: "Convites enviados",
      refresh: "Atualizar",
      refreshing: "Atualizando...",
      loading_waitlist: "Carregando lista...",
      empty_waitlist: "A lista de espera está vazia.",
      loading_invites: "Carregando convites...",
      empty_invites: "Você ainda não gerou convites.",
      th_email: "E-mail",
      th_registered: "Registrado",
      th_status: "Status",
      th_code: "Código",
      th_sent_to: "Enviado para",
      th_sent_by: "Enviado por",
      th_created: "Criado",
      th_used_by: "Usado por",
      pill_registered: "Já registrada",
      pill_code_sent: "Código enviado",
      pill_waiting: "Em espera",
      pill_used: "Usada",
      pill_expired: "Expirada",
      pill_sent_pending: "Enviada · pendente",
      pill_send_failed: "Envio falhou",
      pill_code_only: "Apenas código",
      btn_resend: "Reenviar",
      btn_send_code: "Enviar código",
      btn_sending: "Enviando...",
      sent_to: "Convite enviado para",
      err_load: "Erro ao carregar dados",
      err_send: "Erro ao enviar convite",
      not_sent: "— não enviado",
      member_chip_title: "Insígnia de número de membro",
      member_chip_on: "ON · Os perfis mostram a insígnia «Você é o membro #N da Troly».",
      member_chip_off: "OFF · A insígnia de número de membro está oculta para todos os usuários.",
      member_chip_aria: "Insígnia de número de membro",
    },
    public_profile: {
      meta_desc: "Coleção de {{name}} na Troly",
      loading: "Carregando perfil…",
      not_found: "Colecionador não encontrado.",
      load_error: "Não foi possível carregar este perfil. Tente novamente.",
      his_collection: "Sua Coleção",
      go_to_panel: "Ir ao meu painel",
      back_to_catalog: "Voltar ao catálogo",
      hidden_by_collector: "oculto pelo colecionador",
      join_troly: "Entre no Troly",
      in_garage_his: "na garagem dele",
      empty: "Este colecionador ainda não publicou peças.",
      empty_scale: "Não há peças nesta escala.",
    },
    share: {
      action: "Compartilhar",
      title: "Compartilhar perfil",
      message: "Veja a coleção de {{name}} no Troly",
      email_subject: "A coleção de {{name}} no Troly",
      email: "E-mail",
      copy_link: "Copiar link",
      copied: "Link copiado!",
    },
    follow: {
      follow: "Seguir",
      following: "Seguindo",
      followers_count_one: "{{count}} seguidor",
      followers_count_other: "{{count}} seguidores",
      error: "Não foi possível atualizar o seguimento. Tente novamente.",
    },
    currency: {
      selector_label: "Moeda de exibição",
      original_published_in: "Publicado em {{currency}} {{amount}}",
    },
    terms: {
      meta_title: "Termos e Condições — Troly",
      meta_desc: "Termos e Condições de Uso da Troly, o clube privado para colecionadores de carrinhos e veículos em escala.",
      back_to_home: "Voltar ao início",
      title: "TERMOS E CONDIÇÕES DE USO DA TROLY",
      updated: "Última atualização: maio de 2026",
      intro_p1: "Bem-vindo à Troly. Ao acessar, registrar-se ou utilizar nosso site no domínio (https://troly.club), você concorda em cumprir e estar sujeito aos presentes Termos e Condições de Uso. Caso não concorde com estes termos, deverá abster-se de utilizar a plataforma.",
      intro_p2: "A plataforma é operada pela Constructores de Crecimiento S.A. de C.V., identificada com [DOCUMENTO DE IDENTIDADE em processo de constituição], com sede em Residencial Alta Vitta, Anillo Interior Lomas Verdes 275, Código Postal 53124, Naucalpan de Juárez, Estado de México, doravante denominada “A Empresa”. A empresa também opera https://bido.app",
      s1: {
        num: "1",
        title: "DESCRIÇÃO DOS SERVIÇOS",
        intro: "A Troly funciona como um marketplace especializado e uma comunidade digital projetada para colecionadores de automóveis em escala e outros veículos de coleção. A plataforma permite aos usuários:",
        bullets: [
          "Criar um perfil personalizado e configurar sua biografia ou canais de contato.",
          "Enviar imagens de suas peças para organizar um álbum digital interativo.",
          "Etiquetar cada item com especificações técnicas detalhadas como marca, modelo, escala e valor estimado.",
          "Interagir com outros membros da comunidade através do acompanhamento de perfis e da seção de comentários.",
          "Classificar seus artigos sob dinâmicas específicas como exibição, troca ou venda direta.",
        ],
      },
      s2: {
        num: "2",
        title: "REGISTRO E SEGURANÇA DA CONTA",
        intro: "Para acessar as funções avançadas de publicação e interação, é obrigatório concluir o processo de registro na interface de criação de conta. O usuário compromete-se a:",
        bullets: [
          "Fornecer informações reais, exatas e atualizadas durante o cadastro na plataforma.",
          "Preservar a confidencialidade de suas credenciais de acesso.",
          "Assumir total responsabilidade pelas operações executadas a partir de seu perfil de usuário.",
        ],
        outro: "A Empresa reserva-se o direito de desativar ou suspender as contas que apresentem dados falsos ou atividades suspeitas que afetem a integridade da comunidade.",
      },
      s3: {
        num: "3",
        title: "MODELO DE NEGÓCIO E ASSINATURAS PARA VENDEDORES",
        intro: "A Troly opera sob um modelo de marketplace com assinatura para os usuários que desejam habilitar a funcionalidade de venda direta dentro da plataforma.",
        bullets: [
          { bold: "Assinatura de Vendedor:", text: "Os membros que decidirem comercializar suas peças devem manter ativo um plano de assinatura periódico (mensal ou anual). As tarifas, características e limites de cada plano serão detalhados de forma explícita no dashboard do usuário antes de prosseguir com o pagamento." },
          { bold: "Processamento de Pagamentos via Stripe:", text: "Toda transação financeira derivada da venda de assinaturas ou de compras de artigos entre usuários será processada exclusivamente através do gateway de pagamentos Stripe. Ao utilizar esta funcionalidade, o usuário aceita implicitamente as políticas operacionais e os termos de serviço da Stripe." },
          { bold: "Comissões de Transação:", text: "A Empresa reserva-se o direito de aplicar um percentual de comissão sobre cada venda bem-sucedida realizada dentro do ecossistema da plataforma, o qual será descontado automaticamente através do fluxo de checkout da Stripe. As taxas vigentes serão notificadas claramente na seção correspondente do portal." },
        ],
      },
      s4: {
        num: "4",
        title: "CONDIÇÕES DE ENVIO DE CONTEÚDO E REQUISITOS TÉCNICOS",
        intro: "Ao enviar fotografias ou descrições de sua coleção para o servidor da Troly, o usuário garante que possui os direitos de propriedade intelectual necessários sobre o referido material.",
        bullets: [
          { bold: "Otimização de Imagens:", text: "Para manter a velocidade de carregamento e garantir o desempenho ideal do aplicativo, solicita-se limitar o tamanho de cada imagem enviada a um máximo de 3MB." },
          { bold: "Exatidão da Informação:", text: "O usuário deve assegurar-se de que os campos obrigatórios do formulário (tais como nome do veículo, Código, SKU, marca, categoria e material) correspondam fielmente à peça física real. Caso não conte com o dado exato no momento, poderá inserir um valor provisório e corrigi-lo posteriormente através do editor da publicação." },
        ],
      },
      s5: {
        num: "5",
        title: "RESPONSABILIDADE NAS TRANSAÇÕES DO MARKETPLACE",
        intro: "A Troly provê a infraestrutura tecnológica para conectar compradores e vendedores da comunidade. No entanto, A Empresa não atua como proprietária, fornecedora nem fabricante das peças exibidas pelos usuários em seus perfis individuais.",
        intro2: "Por conseguinte, A Empresa não assume nenhuma responsabilidade por:",
        bullets: [
          "A veracidade das especificações, o estado físico ou a autenticidade dos carrinhos publicados pelos vendedores.",
          "Os inconvenientes logísticos, atrasos ou perdas associadas ao envio e distribuição física dos produtos.",
          "O descumprimento das obrigações fiscais ou tributárias que correspondam às vendas geradas por cada usuário em seu território local.",
        ],
      },
      s6: {
        num: "6",
        title: "PROPRIEDADE INTELECTUAL DA PLATAFORMA",
        body: "As marcas, logotipos, código-fonte, designs de interface, esquemas de banco de dados e ferramentas de software relacionadas à marca Troly são propriedade exclusiva d'A Empresa. Fica estritamente proibida sua reprodução, exploração comercial ou descompilação sem autorização prévia e por escrito.",
      },
      s7: {
        num: "7",
        title: "MODIFICAÇÕES DOS TERMOS",
        body: "A Empresa reserva-se o direito de atualizar, reformar ou substituir seções destes Termos e Condições a qualquer momento para adaptá-los a novas normativas legais ou melhorias operacionais do serviço, tais como futuras ferramentas de avaliação de mercado ou expansão a novas verticais de colecionismo. As modificações entrarão em vigor de forma imediata após sua publicação no endereço web (https://troly.club/terminos).",
      },
      s8: {
        num: "8",
        title: "LEI APLICÁVEL E JURISDIÇÃO",
        body: "Estes Termos e Condições serão regidos e interpretados sob as leis dos Estados Unidos Mexicanos. Qualquer controvérsia judicial ou reclamação derivada do uso da plataforma será submetida aos tribunais competentes do Estado do México, renunciando as partes a qualquer outra jurisdição que possa corresponder-lhes por domicílio atual ou futuro.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V.",
    },
    sorteo: {
      meta_title: "Termos do Sorteio — Troly",
      meta_desc: "Regulamento do sorteio de um Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302 entre os assinantes do plano Troly Pro no México.",
      back_to_home: "Voltar ao início",
      eyebrow: "Sorteio Troly · México",
      title: "Ganhe um Hot Wheels Legends Tour 2026",
      prize_name: "Ford Mustang Boss 302 · com protetor e envio incluído",
      pitch: "A Troly é o lugar ideal para os colecionadores de Carros em Escala. Organize seus carros, descubra o que está faltando e contribua para uma base de dados em constante crescimento, enriquecida pela comunidade.",
      cta: "Assinar o plano Troly Pro",
      cta_fb: "Seguir a Troly no Facebook",
      deadline: "Inscrições abertas até 30 de setembro de 2026, 12:00 (Cidade do México, UTC-6). Sorteio ao vivo em 1 de outubro de 2026.",
      prize_alt: "Hot Wheels Legends Tour 2026 — 69 Ford Mustang Boss 302 na embalagem com protetor",
      prize_caption: "Prêmio: Hot Wheels Legends Tour 2026 · Ford Mustang Boss 302",
      steps: {
        title: "Como participar",
        s1_title: "1 · Assine o plano Troly Pro",
        s1_body: "O plano Troly Pro não tem nenhum custo. Se depois você adquirir o plano Troly Premium, também participa.",
        s2_title: "2 · Envie quatro peças",
        s2_body: "Carregue quatro peças da sua coleção no seu perfil e recebe o seu número de participação.",
        s3_title: "3 · Convide um amigo",
        s3_body: "Cada quatro colecionadores que se cadastrem com o seu código TROLY-XXXX rendem um número extra. Compartilhe no",
        s3_link: "seu perfil",
      },
      numbers: {
        title: "Números atribuídos",
        loading: "Carregando a lista…",
        error: "Não conseguimos carregar a lista de participantes. Tente de novo em instantes.",
        empty: "Ainda não há números atribuídos. O primeiro a cumprir as condições leva o número 1.",
        count_one: "{{count}} número emitido",
        count_other: "{{count}} números emitidos",
        more: "Ver mais números",
        closed: "As inscrições estão encerradas. A lista abaixo é definitiva.",
        body: "A lista de participantes com os seus números é publicada nesta mesma página (https://troly.club/sorteo). Os números são emitidos por ordem de ativação, do um (1) até o N, e uma vez atribuídos não mudam. Um mesmo participante pode ter vários números: um pelas suas quatro peças e mais um por cada quatro colecionadores que convidar.",
      },
      legal_title: "TERMOS E CONDIÇÕES DO SORTEIO «GANHE UM HOT WHEELS LEGENDS TOUR 2026»",
      updated: "Última atualização: agosto de 2026",
      s1: {
        num: "1",
        title: "ORGANIZADOR",
        body: "Esta atividade é organizada por Troly — Bido, com Registro Federal de Contribuintes (RFC) AAMR6811066U5, domiciliada em Naucalpan de Juárez, Estado do México, México, e com e-mail de contato troly@bido.app.",
      },
      s2: {
        num: "2",
        title: "REQUISITOS DE PARTICIPAÇÃO",
        bullets: [
          "Podem participar pessoas físicas maiores de 18 anos.",
          { bold: "Âmbito territorial:", text: "válido apenas no México." },
          "Ficam excluídos de participar os organizadores diretos e o pessoal vinculado à auditoria do sorteio.",
          "Serão excluídos do prêmio os usuários que apresentarem informações falsas.",
          "As contas com perfil de vendedor não participam do sorteio.",
        ],
      },
      s3: {
        num: "3",
        title: "MECÂNICA E ATRIBUIÇÃO",
        bullets: [
          "Participam os usuários cadastrados na Troly com o plano Troly Pro, que não tem nenhum custo, desde a data de publicação deste regulamento e até 30 de setembro de 2026 (12:00). Se o usuário assinar o plano Troly Pro e posteriormente adquirir o plano Troly Premium, também participa.",
          { bold: "Número base:", text: "enviar quatro (4) peças da sua coleção ao perfil da Troly concede um (1) número de participação." },
          { bold: "Números adicionais:", text: "por cada quatro (4) colecionadores que se cadastrem com o seu código de convite pessoal (TROLY-XXXX), disponível no seu perfil, o participante recebe um (1) número adicional. Não há limite de números adicionais." },
          "As quatro peças são condição de entrada: sem elas não se atribui nenhum número, independentemente de quantos convidados tiver.",
          "A participação e os números são ativados automaticamente ao cumprir as condições: não é preciso nenhum trâmite adicional.",
          "Os números são emitidos por ordem de ativação, do número um (1) até o número N, e uma vez atribuídos não são reordenados nem reatribuídos.",
          "Cada rodada do sorteio exige indicações e peças novas: as contribuições já contabilizadas em uma rodada anterior não contam de novo.",
          "Seguir a Troly no Facebook NÃO é requisito para participar; o botão permanece na página como canal de comunidade.",
          "A lista aparecerá em https://troly.club/sorteo",
        ],
      },
      s4: {
        num: "4",
        title: "PRÊMIO",
        bullets: [
          { bold: "Descrição:", text: "um Hot Wheels Legends Tour 2026 — Ford Mustang Boss 302, com protetor e envio ao território mexicano." },
          { bold: "Condições:", text: "o prêmio não é trocável por dinheiro em espécie nem transferível a terceiros, salvo autorização expressa do organizador." },
        ],
      },
      s5: {
        num: "5",
        title: "DATA E MÉTODO DE SELEÇÃO DO GANHADOR",
        bullets: [
          "O sorteio será realizado no dia 1 de outubro de 2026 às 12:00 (fuso horário da Cidade do México, UTC-6).",
          { bold: "Método de determinação:", text: "transmissão ao vivo pelo Facebook, na qual se extrai o número vencedor entre os números atribuídos." },
        ],
      },
      s6: {
        num: "6",
        title: "NOTIFICAÇÃO E ENTREGA DO PRÊMIO",
        bullets: [
          "O ganhador será notificado no prazo máximo de 24 horas, por telefone e/ou e-mail.",
          "O ganhador terá 30 dias corridos para informar os dados de envio ou retirar o prêmio apresentando documento de identidade na sede da Troly: Residencial Alta Vitta, Anillo Interior 275, Torre F, Apto 301, CEP 53124, Naucalpan de Juárez, Estado do México (WhatsApp +52 55 4792 7091).",
          "Se o ganhador não responder ou não cumprir os requisitos nesse prazo, será realizado um novo sorteio entre os mesmos assinantes.",
          { bold: "Custos de envio:", text: "as despesas de envio, fretes, impostos por ganho ocasional ou trâmites correrão por conta da Troly." },
        ],
      },
      s7: {
        num: "7",
        title: "TRATAMENTO DE DADOS PESSOAIS",
        body: "Os dados fornecidos pelos participantes serão utilizados exclusivamente para a gestão do sorteio, o contato com o ganhador e a verificação do sorteio, conforme a normativa vigente de proteção de dados pessoais.",
      },
      s8: {
        num: "8",
        title: "ACEITAÇÃO DO REGULAMENTO",
        body: "A assinatura do plano Troly Pro implica a aceitação total e sem reservas dos presentes termos e condições.",
      },
      regulatory: {
        title: "Pontos regulatórios a considerar segundo a jurisdição",
        body: "Permissões governamentais: nossas projeções para esta atividade comercial não representam um sorteio de grande escala, dos que exigem registro prévio, pagamento de direitos de exploração e apólices de cumprimento perante a SEGOB. Se as assinaturas do marketplace Troly superarem as cifras acordadas para que seja considerado um sorteio de grande escala, será realizada a gestão perante o Governo do México.",
      },
      footer_note: "© 2026 TROLY · Constructores de Crecimiento S.A. de C.V. · A VERSÃO EM ESPANHOL DESTE REGULAMENTO PREVALECE",
    },
  },
};

export default pt;
